import { createSlice } from '@reduxjs/toolkit';
import { pageModel } from '../../utils/model';

const initialState = {
    page: pageModel
}

const operationSlice = createSlice({
    name: 'operation',
    initialState,
    reducers: {
        setOperationPageAction: (state, action) => {
            state.page = action.payload
        },
        getOperationPageAction: (state, action) => {
            const content = state.page.content.concat(action.payload.content)
            state.page = { ...action.payload, content }
        },
        addOperationAction: (state, action) => {
            state.page.content.unshift(action.payload)
        },
        updateOperationAction: (state, action) => {
            const content = state.page.content.map((x) => {
                if (x.id === action.payload.id) return action.payload
                else return x
            })
            state.page.content = content
        },
        deleteOperationAction: (state, action) => {
            const content = state.page.content.filter(p => p.id !== action.payload)
            state.page.content = content
        },
    },
});

export const { setOperationPageAction, getOperationPageAction, addOperationAction, updateOperationAction, deleteOperationAction, uploadPatternExcelFileAction } = operationSlice.actions;
export default operationSlice;